import CardArticleActivity from "@/components/community/article/CardArticleActivity";
import { Config, isProduction } from "@/config";
import { seoConfig } from "@/config/seo.config";
import { BreadcrumbJsonLd, NextSeo } from "next-seo";
import { MetaTag } from "next-seo/lib/types";
import React, { useState } from "react";

type Props = {

}
const ArticlesPage: React.FC<Props> = () => {
  const currentUrl = typeof window !== "undefined" ? window.location.href : `${Config.maaBoom}community/activity`;

  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: 'หน้าแรก',
            item: 'https://maaboom.com',
          },
          {
            position: 2,
            name: 'กิจกรรม',
            item: currentUrl,
          },
        ]}
      />

      <NextSeo
        title="กิจกรรม"
        titleTemplate={`%s | ${seoConfig.title}`}
        defaultTitle={seoConfig.defaultTitle}
        description={seoConfig.description}
        canonical={currentUrl}
        openGraph={{
          ...seoConfig.openGraph,
          url: currentUrl,
          title: `กิจกรรม | ${seoConfig.title}`,
        }}
        additionalMetaTags={[
          ...seoConfig.additionalMetaTags,
          isProduction ? seoConfig.robots.isProduction : seoConfig.robots.isNotProduction,
          {
            name: "twitter:title",
            content: `กิจกรรม | ${seoConfig.title}`,
          },
          {
            name: "twitter:description",
            content: `${seoConfig.description}`,
          },
      ] as MetaTag[]}
        twitter={seoConfig.twitter}
        facebook={seoConfig.facebook}
      />

      <CardArticleActivity title={"กิจกรรม"} articleType={2} />
    </>
  );
};

export default ArticlesPage;

